module.exports = __webpack_public_path__ + "img/icon-storage.0be918f3.svg";